export default __webpack_public_path__ + "static/media/meliVideo_1.50e501d3.mp4";